// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingOverlay_root__DRhxN","filter":"LoadingOverlay_filter___avKc","overlay":"LoadingOverlay_overlay___PMLi","none":"LoadingOverlay_none__I2GHc"};